// Inspecciones "sin ente": se capturan en sitio sin señal y sin saber todavía a qué ente/OT
// pertenecen; al recuperar señal el inspector las asigna (ver AsignarInspeccionDialog). Viven
// en un almacén aparte de offlineEvaluationStore a propósito: el motor de sincronización nunca
// las ve, así que no hay forma de que suban solas a un ente equivocado.
import localforage from 'localforage';

const store = localforage.createInstance({
  name: 'conem-offline',
  storeName: 'async_inspections',
  description: 'Inspecciones capturadas sin ente asignado'
});

const newId = () => `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 8)}`;

const asyncInspectionStore = {
  async create(meta = {}) {
    const now = new Date().toISOString();
    const record = {
      id: newId(),
      meta: { siteName: '', notes: '', gps: null, ...meta },
      data: null,
      createdAt: now,
      updatedAt: now
    };
    await store.setItem(record.id, record);
    return record;
  },

  async get(id) {
    if (!id) return null;
    try {
      return await store.getItem(id);
    } catch (err) {
      console.error('Error leyendo inspección sin ente:', err);
      return null;
    }
  },

  async save(id, { data, meta } = {}) {
    const existing = await store.getItem(id);
    if (!existing) return null;
    const record = {
      ...existing,
      data: data !== undefined ? data : existing.data,
      meta: meta !== undefined ? { ...existing.meta, ...meta } : existing.meta,
      updatedAt: new Date().toISOString()
    };
    await store.setItem(id, record);
    return record;
  },

  async list() {
    const items = [];
    try {
      await store.iterate((value) => { if (value?.id) items.push(value); });
    } catch (err) {
      console.error('Error listando inspecciones sin ente:', err);
    }
    return items.sort((a, b) => String(b.updatedAt).localeCompare(String(a.updatedAt)));
  },

  async count() {
    try {
      return await store.length();
    } catch {
      return 0;
    }
  },

  async remove(id) {
    await store.removeItem(id);
  }
};

export default asyncInspectionStore;
